/* @flow */
import apiRequest from 'lib/apiRequest';
import ReactionEmoji from 'entities/ReactionEmoji';
import Collection from 'lib/Collection';

export default class ReactionEmojis extends Collection {
  parse(response: Object) {
    return response.map(reaction => ReactionEmoji.fromJSON(reaction));
  }

  // $FlowFixMe
  static fetch(): Promise<ReactionEmojis> {
    return apiRequest('/messages/reactions', 'GET').then(
      response => ReactionEmojis.fromJSON(response)
    );
  }
}



// WEBPACK FOOTER //
// ./src/collections/ReactionEmojis.js